<template>
  <section class="intensives">
    <div class="intensives__banner">
      <TopBanner class="mb-16" :item="banner" />
    </div>
    <div
      class="container _py-16 _py-md-12"
      v-if="getIntensiveList && getIntensiveList !== null"
    >
      <div class="sections__list d-grid row-1-1 gap-32">
        <SectionCard
          v-for="block in formattedIntensivesList"
          :key="block.id"
          :item="block"
          @click.native="
            dataLayerPush(block.title, {
              name: 'Intensive',
              params: { slug: block.slug },
            })
          "
        >
          <template v-slot:image>
            <img :src="block.preview_thumbnail" alt="" />
          </template>
        </SectionCard>
      </div>
    </div>

    <div class="d-flex justify-center _my-6" v-else>
      <Preloader />
    </div>

    <div class="slider-block">
      <SocialsSlider :analyticEventPrefix="'intensive'" />
      <div class="bottom-banner__container" v-if="false">
        <div class="container _pb-12 _pb-md-12 _px-md-4">
          <div class="bottom-banner _pa-8">
            <picture>
              <source
                :srcset="
                  require('@/assets/img/blocks/intensives/block-1920.jpg')
                "
                media="(min-width: 1920px)"
              />
              <source
                :srcset="
                  require('@/assets/img/blocks/intensives/block-768.jpg')
                "
                media="(max-width: 1220px)"
              />
              <img
                class="bottom-banner__img d-none d-md-block"
                :src="require('@/assets/img/blocks/intensives/block-1920.jpg')"
              />
            </picture>
            <div class="bottom-banner__text-container">
              <h3
                class="bottom-banner__title _mb-2 _fw-600 _lh-38 _fs-32 _fs-sm-24 _lh-sm-32"
              >
                {{ $t("pages.home.bottom_block.title") }}
              </h3>
              <p
                class="bottom-banner__description _fs-20 _lh-26 _fs-sm-14 _lh-sm-20"
              >
                {{ $t("pages.home.bottom_block.description") }}
              </p>
              <AppBtn :btnClass="'btn_orange'" class="_mt-4">
                <div
                  @click="bottomBannerClick()"
                  class="_tc-white _fs-18 _py-2 _px-3"
                >
                  {{ $t("pages.home.bottom_block.more") }}
                </div>
              </AppBtn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import TopBanner from "@/components/UI/banners/TopBanner";
import SectionCard from "@/components/UI/cards/SectionCard";
import SocialsSlider from "../../components/UI/SocialsSlider.vue";
import AppBtn from "@/components/UI/buttons/AppBtn";
import Preloader from "@/components/UI/Preloader";
import toPage from "@/mixins/toPage";
import { mapActions, mapGetters } from "vuex";

export default {
  metaInfo() {
    return { title: this.$t("interface.menu.intensives") };
  },
  name: "IntensivesMain",
  components: {
    TopBanner,
    SectionCard,
    SocialsSlider,
    AppBtn,
    Preloader,
  },
  mixins: [toPage],
  data: () => ({}),
  computed: {
    ...mapGetters(["getIntensiveList"]),
    banner() {
      return {
        title: this.$t("pages.intensives.title"),
        descr: this.$t("pages.intensives.description"),
        theme: "dark",
        images: [
          {
            src: require("@/assets/img/banners/intensives/INT-mob.jpg"),
            media: "(max-width: 743px)",
          },
          {
            src: require("@/assets/img/banners/intensives/INT-tab.jpg"),
            media: "(max-width: 1220px)",
          },
          {
            src: require("@/assets/img/banners/intensives/INT-1440.jpg"),
            media: "(max-width: 1919px)",
          },
          {
            src: require("@/assets/img/banners/intensives/INT-1920.jpg"),
            media: "(min-width: 1920px)",
          },
        ],
      };
    },
    currentLocale() {
      return this.Trans.currentLocale;
    },
    formattedIntensivesList() {
      const vm = this;
      return this.getIntensiveList.map(function (el) {
        return {
          ...el,
          title: vm.getTranslate(el).title.replace(/[<]br[^>]*[>]/gi, " "),
          preview_thumbnail: vm.getTranslate(el).preview_thumbnail,
          preview: vm.getTranslate(el).preview,
          description: vm
            .getTranslate(el)
            .description.replace(/[<]br[^>]*[>]/gi, " "),
        };
      });
    },
  },
  methods: {
    ...mapActions(["fetchIntensiveList"]),
    getTranslate(item) {
      return item.translates[0];
    },
    bottomBannerClick() {
      if (this.$gtm) {
        this.$gtm.push({
          event: "intensive_banner_more",
        });
      }
      this.$router.push(this.helpers.buildRoute({ name: "UsefulResources" }));
    },
    dataLayerPush(txt, path) {
      if (this.$gtm) {
        this.$gtm.push({
          event: "intensive_module",
          param_value: this.helpers.stripHtml(txt),
        });
      }
      this.toPage(path);
    },
  },
  async mounted() {
    await this.fetchIntensiveList(this.currentLocale);
  },
};
</script>

<style lang="scss">
.row-1-1 {
  grid-template-columns: 1fr 1fr;

  @media screen and (max-width: 1220px) {
    grid-template-columns: 1fr;
  }
}

.gap-32 {
  grid-gap: 32px;
}
</style>

<style lang="scss" scoped>
.intensives {
  &__banner {
    background-color: #DDEBE9;
  }

  .top-banner {
    max-width: 1920px;
    margin: 0 auto;
  }
}
.bottom-banner {
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  width: 100%;
  min-height: 196px;
  background-image: radial-gradient(
    74.59% 137.08% at 100% 58.47%,
    #96b2eb 0%,
    #4865a6 100%
  );

  @media screen and (max-width: 1220px) {
    height: auto;
  }

  &__img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  &__text-container {
    max-width: 55%;
    position: relative;
    z-index: 2;
    color: color(white);

    @media screen and (max-width: 1220px) {
      max-width: 45%;
    }

    @media screen and (max-width: 743px) {
      max-width: none;
    }
  }
}

.slider-block {
  background-color: color(light);
}
</style>
